import { Plus, X } from 'lucide-react'
import { useFormContext } from 'react-hook-form'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Textarea } from '@/components/ui/textarea'
import type { RecipeFormData } from '@/types/recipe'

export function RecipeFormInstructions() {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<RecipeFormData>()

  const instructions = watch('instructions')

  const appendInstruction = () => {
    setValue('instructions', [...instructions, ''])
  }

  const removeInstruction = (index: number) => {
    setValue(
      'instructions',
      instructions.filter((_, instructionIndex) => instructionIndex !== index)
    )
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Bereidingswijze</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {instructions.map((instruction, index) => (
            <div key={`instruction-${index}-${instruction}`} className="flex gap-2">
              <div className="flex h-10 w-8 flex-shrink-0 items-center justify-center rounded bg-primary-100 text-sm font-medium text-primary-600">
                {index + 1}
              </div>
              <Textarea
                {...register(`instructions.${index}`)}
                placeholder="Beschrijf deze stap..."
                rows={2}
                className={errors.instructions?.[index] ? 'border-red-500' : ''}
              />
              {instructions.length > 1 ? (
                <Button type="button" variant="outline" size="sm" onClick={() => removeInstruction(index)}>
                  <X className="h-4 w-4" />
                </Button>
              ) : null}
            </div>
          ))}

          <Button type="button" variant="outline" onClick={appendInstruction} className="w-full">
            <Plus className="mr-2 h-4 w-4" />
            Stap Toevoegen
          </Button>
        </div>

        {errors.instructions ? <p className="mt-1 text-sm text-red-500">{errors.instructions.message as string}</p> : null}
      </CardContent>
    </Card>
  )
}
